// [목적] '/' 진입 시 인증 상태에 따라 LandingPage(guest) / App 셸(authenticated) 로 분기
// [이유] 기존 routes.tsx 의 path:'/' 는 App 셸 + index→HomePage 였음. 마케팅 랜딩과 로그인 사용자 홈을
//         같은 / 경로에서 분기하기 위해 라우트 element 만 본 컴포넌트로 교체.
// [사이드 이팩트] / 외 경로(/chat, /explore 등)는 항상 App 셸 통과 — 기존 동선 무중단.
//                 status==='loading' 시 / 경로는 빈 배경(C.bg)으로 한 프레임 placeholder — 인증 결과 확정 후 분기.
//                 비인증 사용자의 /chat 등 공개 라우트 진입은 App 셸 그대로 유지 (사이드바·BottomTabBar 노출).
// [수정 시 고려사항] AuthProvider 가 RouterProvider 상위에 위치해야 useAuthContext() 호출 가능 (main.tsx 보장).
//                   loading→authenticated 전환 시 1회 리렌더 발생 — 플리커 최소화를 위해 빈 배경만 노출.

import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { App } from '../../App.js';
import { LandingPage } from '../../pages/LandingPage.js';
import { LANDING_COLORS } from '../../pages/landing/tokens.js';
import { useAuthContext } from '../../providers/AuthProvider.js';

/**
 * [목적] / 라우트 element — guest 면 LandingPage, 그 외 경로/상태는 App 셸
 * [이유] LandingPage 는 자체 Header/Footer 를 가져 App 셸과 중첩 시 시각 충돌
 * [사이드 이팩트] / 가 아닌 경로(/chat 등)는 항상 App 렌더 — Outlet 으로 children 라우트 전개
 * [수정 시 고려사항] location.pathname === '/' 정확 일치 — trailing slash 정규화는 React Router 기본 동작에 의존
 */
export function RootSwitch(): JSX.Element {
  const { status } = useAuthContext();
  const { pathname } = useLocation();
  const isRoot = pathname === '/';

  // / 경로에서 인증 결과 대기 중 — 빈 배경으로 플리커 방지
  if (isRoot && status === 'loading') {
    return <Box sx={{ minHeight: '100vh', bgcolor: LANDING_COLORS.bg }} aria-hidden="true" />;
  }

  // / 경로 + 미인증 → 랜딩 페이지 (App 셸 우회)
  if (isRoot && status === 'guest') {
    return <LandingPage />;
  }

  // 그 외 (인증된 / · 모든 비-루트 경로) → 기존 App 셸 + Outlet
  return <App />;
}
